import { AppStoreBadges } from '@/components/app-store-badges';
import { Section, Title } from '@/components/ui/layout';
import { Discovery } from '@/donor/discovery';
import { HomeGiving } from '@/donor/home-giving';
import { Church, HandCoins, HeartHandshake } from 'lucide-react';

import { useLanguage } from '@/i18n/language-context';
import { usePageMetadata } from '@/i18n/use-page-metadata';
import { SiteShell } from '@/components/site-shell';
import { useDeveloperFeatures } from '@/lib/developer-features';

export const HomePage = (): JSX.Element => {
  const { t } = useLanguage();
  const { search } = useDeveloperFeatures();
  usePageMetadata();

  return (
    <SiteShell>
      <main id="main-content" tabIndex={-1} className="app-home">
        <Section className="app-home__card" aria-labelledby="app-name">
          <div className="app-home__intro">
            <img className="app-home__logo" src="/brand/mark.svg" alt="" />
            <p className="eyebrow">{t.unionName}</p>
            <Title level={1} id="app-name">
              {t.appName}
            </Title>

            {search && <Discovery />}
            <AppStoreBadges placement="home" />
          </div>

          <div className="app-home__uses">
            <Title level={2}>{t.appUses}</Title>
            <ul>
              <li>
                <span>
                  <Church aria-hidden />
                </span>
                <div>
                  <strong>{t.tithe}</strong>
                  <p>{t.titheUse}</p>
                </div>
              </li>
              <li>
                <span>
                  <HandCoins aria-hidden />
                </span>
                <div>
                  <strong>{t.offerings}</strong>
                  <p>{t.offeringUse}</p>
                </div>
              </li>
              <li>
                <span>
                  <HeartHandshake aria-hidden />
                </span>
                <div>
                  <strong>{t.projects}</strong>
                  <p>{t.projectUse}</p>
                </div>
              </li>
            </ul>
          </div>
        </Section>
        {search && <HomeGiving />}
      </main>
    </SiteShell>
  );
};
